<template>
    <b-row>
        <b-col cols="12">
            <div class="card">
                <div class="card-body">
                    <b-row>
                        <b-col md="8">
                            <h4 class="card-title">{{$t('order.orderregels')}}</h4>
                        </b-col>
                        <b-col md="4">
                            <b-btn size="sm" id="addButton" v-on:click="goAddLine" variant="themecolor" class="waves-effect pull-right">
                                {{$t('buttons.toevoegen')}}
                            </b-btn>
                        </b-col>
                    </b-row>
                    <b-table show-empty stacked="md"
                        class="table-hover lines-table"
                        :items="orderLines"
                        :fields="orderLineFields"
                        @row-clicked="onRowClicked"
                        :empty-text="getEmptyText(0)" 
                        foot-clone
                    >
                        <template v-slot:cell(lineNumber)="row">{{row.index + 1}}</template>
                        <template v-slot:cell(purchaseAmount)="data">{{data.item.purchaseAmount | currency}}</template>
                        <template v-slot:cell(salesAmount)="data">{{data.item.salesAmount | currency}}</template>
                        
                        <template v-slot:cell(actions)="row">
                            <div class="pull-right">
                                <b-button size="sm" variant="themecolor" @click.stop="goEditLine(row.item)">
                                    <i class="fa fa-edit" aria-hidden="true"></i>
                                </b-button>
                                <b-button size="sm" variant="danger" @click.stop="goDeleteLine(row)">
                                    <i class="fa fa-remove" aria-hidden="true"></i>
                                </b-button>    
                            </div>                            
                        </template>
                        <template v-slot:foot(lineNumber)="" >
                            <span>&nbsp;</span>
                        </template>
                        <template v-slot:foot(description)="">
                            <strong>{{$t('order.totalen')}}:</strong>
                        </template>
                        <template v-slot:foot(purchaseAmount)="">
                            <strong>{{totalPurchaseAmount | currency}}</strong>
                        </template>
                        <template v-slot:foot(salesAmount)="">
                            <strong>{{totalSalesAmount | currency}}</strong>
                        </template>
                        <template v-slot:foot(actions)="">
                            <strong>(excl. BTW)</strong>
                        </template>                        
                        <template v-slot:row-details="row">
                            <small class="text-muted"> {{$t('datatables.omschrijving')}}</small>
                            <h6>{{row.item.description}}</h6>

                            <small class="text-muted">{{$t('order.oplage')}}</small>
                            <h6>{{row.item.edition ? row.item.edition : 'Niet opgegeven'}}</h6>
                        
                            <small class="text-muted">{{$t('order.omvang')}}</small>
                            <h6>{{row.item.size ? row.item.size : 'Niet opgegeven'}}</h6>
                        
                            <small class="text-muted">{{$t('order.formaat')}}</small>
                            <h6>{{row.item.format ? row.item.format : 'Niet opgegeven'}}</h6>
                        
                            <small class="text-muted">{{$t('order.bedrukking')}}</small>
                            <h6>{{row.item.printing ? row.item.printing : 'Niet opgegeven'}}</h6>

                            <small class="text-muted">{{$t('order.materiaal')}}</small>
                            <h6>{{row.item.material ? row.item.material : 'Niet opgegeven'}}</h6>
                        
                            <small class="text-muted">{{$t('order.afwerking')}}</small>
                            <h6>{{row.item.finish ? row.item.finish : 'Niet opgegeven'}}</h6>

                            <small class="text-muted"> {{$t('datatables.prijsinkoop')}}</small>
                            <h6>{{row.item.purchaseAmount | currency}}</h6>
                        
                            <small class="text-muted"> {{$t('datatables.prijsverkoop')}}</small>
                            <h6>{{row.item.salesAmount | currency}}</h6>

                            <small class="text-muted"> {{$t('order.opmerking')}}</small>
                            <h6>{{row.item.note ? row.item.note : 'Niet opgegeven'}}</h6>
                        </template>
                    </b-table>
                    <b-row>
                        <b-col id="orderForm" cols="12" class="p-4" v-if="isAddingLine || isEditingLine">
                            <b-form-group label-cols :label="$t('datatables.omschrijving')">
                                <b-form-input :placeholder="$t('datatables.omschrijving')" v-model="command.description" />
                                <validation element="description" :message="$t('validatie.geefeenomschrijvingop')"/>
                            </b-form-group>
                    
                            <b-form-group label-cols :label="$t('order.oplage')">
                                <b-form-input type="text" :placeholder="$t('order.oplage')" v-model="command.edition" />
                            </b-form-group>

                            <b-form-group label-cols :label="$t('order.omvang')">
                                <b-form-input type="text" :placeholder="$t('order.omvang')" v-model="command.size" />
                            </b-form-group>
                    
                            <b-form-group label-cols :label="$t('order.formaat')">
                                <b-form-input type="text" :placeholder="$t('order.formaat')" v-model="command.format" />
                            </b-form-group>

                            <b-form-group label-cols :label="$t('order.bedrukking')">
                                <b-form-input type="text" :placeholder="$t('order.bedrukking')" v-model="command.printing" />
                            </b-form-group>
                    
                            <b-form-group label-cols :label="$t('order.materiaal')">
                                <b-form-input type="text" :placeholder="$t('order.materiaal')" v-model="command.material" />
                            </b-form-group>

                            <b-form-group label-cols :label="$t('order.afwerking')">
                                <b-form-input type="text" :placeholder="$t('order.afwerking')" v-model="command.finish" />
                            </b-form-group>
                            
                            <b-form-group label-cols :label="$t('datatables.prijsinkoop')">
                                 <vue-numeric currency="" separator="." v-bind:precision="2" v-model="command.purchaseAmount"  class="form-control" id="purchaseAmount" />
                            </b-form-group>
                            <b-form-group label-cols :label="$t('datatables.prijsverkoop')">
                                 <vue-numeric currency="" separator="." v-bind:precision="2" v-model="command.salesAmount"  class="form-control" id="salesAmount" />
                            </b-form-group>

                            <b-form-group label-cols :label="$t('order.opmerking')">
                                <b-form-textarea type="text" :placeholder="$t('order.opmerking')" v-model="command.note"  :rows="3" :max-rows="6" />
                            </b-form-group>
                            
                            <b-row>
                                <b-col cols="12">
                                    <div class="pull-right my-1">
                                        <b-button v-if="isAddingLine" @click="cancelAddLine()" size="sm" variant="secondary">{{$t('buttons.annuleren')}}</b-button>   
                                        <b-button v-else-if="isEditingLine" @click="cancelEditLine()" size="sm" variant="secondary">{{$t('buttons.annuleren')}}</b-button>                                        
                                        <b-button v-if="isAddingLine" @click="addLine()" size="sm" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
                                        <b-button v-else-if="isEditingLine" @click="editLine()" size="sm" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </b-col>
    </b-row>
</template>
<script>
//Import command
import Command from './command'
import $ from 'jquery'
import { getEmptyText } from '@/views/root/GetMessageTextHelper';

import { mapGetters, mapActions } from "vuex";

export default {
    components: {},
    data () {
        return {
            useApi : this.invokeApi == true,
            lineCounter:0,
            command: new Command(),
            isAddingLine: false,
            isEditingLine: false
        }
    },
    props: ['orderLines','invokeApi'],
    computed: 
    {
        orderLineFields() {
            return [
                { key: 'lineNumber', label: this.$i18n.t('datatables.nr'), sortable: true },
                { key: 'description', label: this.$i18n.t('datatables.omschrijving'), sortable: true},
                { key: 'purchaseAmount', label: this.$i18n.t('datatables.prijsinkoop'), sortable: true},
                { key: 'salesAmount', label: this.$i18n.t('datatables.prijsverkoop'), sortable: true},
                { key: 'actions', label: ''},
            ]
        },
        totalPurchaseAmount: function () {
            return this.orderLines.map(x => x.purchaseAmount).reduce((a, b) => a + b, 0);
        },
        totalSalesAmount: function () {
            return this.orderLines.map(x => x.salesAmount).reduce((a, b) => a + b, 0);
        },
        ...mapGetters('comceptum',['workOrder'])
    },
    methods: {
        ...mapActions('comceptum',['all','create','update','delete']),
        goAddLine() {
            this.isEditingLine = false;
            this.isAddingLine = true;

            this.command = new Command();
            this.command.customId = this.lineCounter;

            var vm = this;
            setTimeout(function() {
                vm.$scrollTo("#orderForm", 250, { easing: 'ease-in', offset: -250 });
                $("#description").focus();

            },100);
        },
        addLine() {
            var vm = this;
            if(!vm.validateInputs()) return;

            var line = vm.command;
            
            line.purchaseAmount = vm.$options.filters.fullToCent(line.purchaseAmount);
            line.salesAmount = vm.$options.filters.fullToCent(line.salesAmount);

            if(vm.useApi) 
            {
                if(vm.workOrder != undefined) {
                    let reference = vm.workOrder.reference;
                    if(reference !== '') {
                        reference += ", ";
                    }
                    reference += line.description + ",";
                    reference = reference.slice(0, -1);
                    vm.$emit("updateReference",reference);
                }
                vm.create({ resource: 'orderlines', params: line })
                .then((data) => {
                    line._showDetails = false;
                    vm.orderLines.push(data);
                });
            }
            else 
            {
                vm.orderLines.push(line);
            }

            vm.lineCounter++;
            
            vm.command = new Command();

            vm.isAddingLine = false;

            $(".card").css('border','none');
        },
        goEditLine(line) {
            var vm = this;

            vm.isAddingLine = false;
            vm.isEditingLine = true;

            vm.command = new Command(line);
            vm.command.purchaseAmount = vm.$options.filters.centToFull(line.purchaseAmount).replace(".",",");
            vm.command.salesAmount = vm.$options.filters.centToFull(line.salesAmount).replace(".",",");

            setTimeout(function() {
                vm.$scrollTo("#orderForm", 250, { easing: 'ease-in', offset: -250 });
                $("#description").focus();

            },100);
        },
        editLine() {
            var foundIndex = -1;
            var vm = this;
            
            if(vm.command.id) 
            {
                foundIndex = vm.orderLines.findIndex(x=> x.id == vm.command.id);
            }
            else 
            {
                foundIndex = vm.orderLines.findIndex(x => x.customId == vm.command.customId);
            }
            if(foundIndex > -1) 
            {
                let line = new Command(vm.command);
                line.purchaseAmount = vm.$options.filters.fullToCent(line.purchaseAmount);
                line.salesAmount = vm.$options.filters.fullToCent(line.salesAmount);

                if(vm.useApi) 
                {
                    vm.update({ resource: 'orderlines', params: line })
                    .then((data) => 
                    {
                        var item = vm.orderLines[foundIndex];

                        Object.keys(data).forEach(key => {
                            item[key] = data[key]
                        })
                        vm.isEditingLine = false;
                    });
                }
                else 
                {
                    var item = vm.orderLines[foundIndex];

                    Object.keys(vm.command).forEach(key => {
                        item[key] = line[key]
                    })
                    vm.isEditingLine = false;
                }
            }
        },
        goDeleteLine(row)
        {
            var vm = this;
            vm.$swal ({
                title: `${this.$i18n.t('delete.regelverwijderen')}`,
                text: `${this.$i18n.t('delete.weetuzekerdatudezeorderregelwiltverwijderen')}?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: this.$i18n.t('delete.javerwijderen'),
                cancelButtonText: this.$i18n.t('delete.neeannuleren')
            })
            .then((result) => {
                if (result.value) {
                    if(vm.useApi) 
                    {
                        vm.delete({
                            resource: 'orderlines', 
                            id: row.item.id
                        })
                        .then(() => {
                            vm.$swal(this.$i18n.t('delete.succesvol'), `${this.$i18n.t('delete.deorderregelisverwijderd')}`, this.$i18n.t('delete.succes'));   

                            vm.orderLines.splice(row.index,1);
                        })
                        .catch(() => {
                            vm.$swal(this.$i18n.t('delete.mislukt'), `${this.$i18n.t('delete.deorderregelkonnietwordenverwijderd')}`, this.$i18n.t('delete.error'));
                        });
                    }
                    else {
                        vm.orderLines.splice(row.index,1);
                    }
                }
            });
        },
        cancelAddLine() 
        {
            this.isAddingLine = false;
            this.command = new Command();
        },
        cancelEditLine() 
        {
            this.isEditingLine = false;
            this.command = new Command();
        },
        validateInputs() {
            $("#description").parent().toggleClass("has-danger", false);
            $("#purchaseAmount").parent().toggleClass("has-danger", false);
            $("#salesAmount").parent().toggleClass("has-danger", false);

            var vm = this;

            let allCorrect = true;
            if (vm.command.description === "") {
                $("#description").parent().toggleClass("has-danger", true);
                allCorrect = false;
            }
            if(isNaN(vm.command.purchaseAmount)) {
                $("#purchaseAmount").parent().toggleClass("has-danger", true);
                allCorrect = false;
            }
            if(isNaN(vm.command.salesAmount)) {
                $("#salesAmount").parent().toggleClass("has-danger", true);
                allCorrect = false;
            }
            return allCorrect;
        },
        onRowClicked(row) 
        {
            row._showDetails = !row._showDetails;
        },
        getEmptyText,
    }
}
</script>